import React from 'react'
import helpIcon from '../../../imgs/helpicon.svg'


const ProfileMoreMenu = () => {
    return (
        <div className="more-menu">
            <a className="sidebar-links active">
                <span><img src={helpIcon} alt="logo" /></span>Help
            </a>
        </div>
    )
}

export default ProfileMoreMenu;
